import React from 'react';
import { BRAND_TEACHER } from '../../config/brand';
import HomeSectionFrame from './HomeSectionFrame';

const HomeWelcomeBox: React.FC = () => (
  <HomeSectionFrame id="welcome" aria-labelledby="welcome-heading" tone="paper" className="pt-2 sm:pt-3">
    <div className="mx-auto max-w-3xl text-center">
      <p className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-brand-200 bg-brand-50 px-4 py-1.5 text-sm font-bold text-brand-700 sm:text-base">
        <span>دفعة 2027</span>
      </p>

      <h2
        id="welcome-heading"
        className="text-[clamp(1.45rem,1.8vw+1rem,2.1rem)] font-extrabold leading-[1.45] text-slate-900"
      >
        أهلًا بيك، يا بطل منور المنصة!
      </h2>

      <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base sm:leading-8">
        مع {BRAND_TEACHER}، شرح مبسّط ومنظّم للغة الإنجليزية لطلاب الثانوية — أسلوب واضح وتدرّج يناسب كل
        المستويات.
      </p>

      <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base sm:leading-8">
        معانا هتذاكر بثقة: كورسات مرتّبة، متابعة تقدم، ودعم فني طول السنة.
      </p>
    </div>
  </HomeSectionFrame>
);

export default HomeWelcomeBox;
